import "./locales/i18n"
import "simplebar/src/simplebar.css"
import "react-lazy-load-image-component/src/effects/blur.css"
import {useEffect} from "react"
import {BrowserRouter} from "react-router-dom"
import {HelmetProvider} from "react-helmet-async"
import Router from "./routes"
import ThemeProvider from "./theme"
import ThemeLocalization from "./locales"
import SnackbarProvider from "./components/snackbar"
import {SettingsProvider, ThemeSettings, useSettingsContext} from "./components/settings"
import {MotionLazyContainer} from "./components/animate"
import ScrollToTop from "./components/scroll-to-top"
import {AuthProvider} from "./auth/AuthProvider"
import BusFavicon from "./assets/favicon/BusFavicon"
import GlobalDebug from "./utils/GlobalDebug"
import BusControlIcon from "./assets/icons/BusControlIcon"

export default function App() {
    const {appName, companyName} = useSettingsContext()

    const link = document.querySelector("link[rel~='icon']")
    const manifestLink = document.querySelector("link[rel~='manifest']")

    useEffect(() => {
        link.href = `${BusFavicon()}`
        manifestLink.href = `${getManifestURL()}`
        GlobalDebug(process.env.REACT_APP_ENV)
    }, [])

    function createManifest() {
        return ({
            name: `${appName} ${companyName}`,
            short_name: appName,
            display: "standalone",
            start_url: window.location.href,
            theme_color: "#000000",
            background_color: "#ffffff",
            icons: [
                {
                    src: `${BusControlIcon()}`,
                    sizes: "any",
                    type: "image/svg+xml"
                }
            ]
        })
    }

    function getManifestURL() {
        const manifest = createManifest()
        const manifestEncode = encodeURIComponent(JSON.stringify(manifest))

        return `data:application/json;charset=utf-8,${manifestEncode}`
    }

    return (
        <AuthProvider>
            <HelmetProvider>
                <SettingsProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <MotionLazyContainer>
                            <ThemeProvider>
                                <ThemeSettings>
                                    <ThemeLocalization>
                                        <SnackbarProvider>
                                            <Router />
                                        </SnackbarProvider>
                                    </ThemeLocalization>
                                </ThemeSettings>
                            </ThemeProvider>
                        </MotionLazyContainer>
                    </BrowserRouter>
                </SettingsProvider>
            </HelmetProvider>
        </AuthProvider>
    )
}